import truncate from "html-truncate";
import { useState } from "react";
import HtmlContent from "../../../components/HTMLContent";
import { cn } from "../../../lib/utils";

const LongText = ({ content, maxLength = 100, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle between expanded and collapsed view
  const toggleView = () => {
    setIsExpanded(!isExpanded);
  };

  // Function to return a truncated version of HTML content
  const getTruncatedContent = () => {
    return truncate(content, maxLength);
  };

  return (
    <div className={cn("text-sm", className)}>
      <HtmlContent html={isExpanded ? content : getTruncatedContent()} />

      {/* Show the toggle link */}
      {content?.length > maxLength && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a href="#" onClick={toggleView} className="text-webPrimary underline">
          {isExpanded ? "View Less" : "View More"}
        </a>
      )}
    </div>
  );
};
export default LongText;
